import { render, staticRenderFns } from "./panel-compact.vue?vue&type=template&id=5c9f49d0&"
import script from "./panel-compact.vue?vue&type=script&lang=js&"
export * from "./panel-compact.vue?vue&type=script&lang=js&"
import style0 from "./panel-compact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\uds\\projects\\alpheios\\components\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5c9f49d0', component.options)
    } else {
      api.reload('5c9f49d0', component.options)
    }
    module.hot.accept("./panel-compact.vue?vue&type=template&id=5c9f49d0&", function () {
      api.rerender('5c9f49d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/panel-compact.vue"
export default component.exports